<form [formGroup]="dataForm" class="without-default-focus">
	<div class="form-item">
		<mat-form-field class="mat-form-field-title">
			<mat-label>Titre de la notification</mat-label>
			<input matInput data-input-title type="text" formControlName="textForm" autocomplete="off" required tabindex="11" />
			@if (dataForm.errors && dataForm.errors['titre'].required && (dataForm.controls['titre']?.dirty || dataForm.controls['titre'].touched)) {
				<mat-error data-input-title-error>Le champ 'titre' est obligatoire</mat-error>
			}
		</mat-form-field>
	</div>

	<div class="form-item">
		<mat-form-field class="mat-form-field-text">
			<mat-label>Texte de la notification</mat-label>
			<input matInput data-input-text type="text" formControlName="titleForm" autocomplete="off" required tabindex="11" />
			@if (dataForm.errors && dataForm.errors['text'].required && (dataForm.controls['text']?.dirty || dataForm.controls['text'].touched)) {
				<mat-error data-input-title-error>Le champ 'texte' est obligatoire</mat-error>
			}
		</mat-form-field>
	</div>
</form>
